import apiClient from '@/services/api/apiClient';
import { QueryParams } from '@/model';
import { buildApiUrl } from '../utils';
import {
  GetStoreMainBannerByIdResponse,
  GetStoreMainBannerResponse,
  PostStoreMainBannerByIdResponse,
  PutStoreMainBannerByIdResponse,
} from '../response/store-main-banner';

export class StoreMainBannerService {
  static getStoreMainBanners(params?: QueryParams) {
    return apiClient.get<GetStoreMainBannerResponse>(buildApiUrl('/api/v1/media/store/main-banner'), params);
  }

  static postStoreMainBanner(data: any) {
    return apiClient.createWithFile<PostStoreMainBannerByIdResponse>(buildApiUrl('/api/v1/media/store/main-banner'), data);
  }

  static getStoreMainBannerById(id: string) {
    return apiClient.get<GetStoreMainBannerByIdResponse>(buildApiUrl('/api/v1/media/store/main-banner/:id', { id }), undefined);
  }

  static putStoreMainBanner(id: string, data: any) {
    return apiClient.updateWithFile<PutStoreMainBannerByIdResponse>(buildApiUrl('/api/v1/media/store/main-banner/:id', { id }), data);
  }

  static deleteStoreMainBanner(id: string) {
    return apiClient.delete<void>(buildApiUrl('/api/v1/media/store/main-banner/:id', { id }), undefined);
  }
}
